import actions from '../actions/FavoritesActions';
import { cutoffs, sortBy, tabs } from '../constants';

const {
    RESET_UI_STATE,
    SET_READY_TO_RENDER,
    ROUTER_NAVIGATION,
    SELECT_PORTFOLIOS,
    SELECT_ITEMS,
    SET_CREATE_FOLDER_ON_LOAD,
    SET_CURRENCY,
    SET_EDIT_MODE,
    SET_FAVORITE_ITEM_ON_LOAD,
    SET_FULL_PAGE_LOADING,
    SET_PARTIAL_PAGE_LOADING,
    SET_MUTATION_RESPONSE,
    SET_NUM_ITEMS,
    INCREASE_NUM_ITEMS,
    SET_PORTFOLIO_IDS,
    SET_PORTFOLIO_NAME,
    SET_PORTFOLIO_TYPES,
    SET_PORTFOLIO_VIEW_PERMISSION,
    SET_PROJECT_ID,
    SET_REORDERED,
    SET_REORDER_MODE,
    SET_SEARCH_TERM,
    SET_SELECT_ALL,
    SET_SELECT_MODE,
    SET_SORT_BY,
    SET_TAB,
    SET_TAB_CHANGED,
    SET_TOTAL_RESULTS,
    SET_SHOULD_TRACK_REORDERING,
    SET_USER_HAS_CHANGED,
    SET_VIEWING_PUBLIC_VERSION,
    SET_STICK_TOOLBAR,
    SET_VIEW_MODE,
    SLIDE_NAV_BORDER,
    SET_AUTH_MODAL_STATE,
    SET_PAGE,
} = actions;

const uiState = (state = {}, payload) => {
    switch (payload.type) {
        case RESET_UI_STATE:
            return {
                ...state,
                editing: false,
                first: payload.retainItems ? state.first : cutoffs.ADDITIONAL_ITEMS,
                folderSort: sortBy.CUSTOM,
                foldersSort: sortBy.CUSTOM,
                page: payload.retainItems ? state.page : 1,
                reordered: false,
                reordering: false,
                selectAllStatus: '',
                selectedItems: [],
                selectedPortfolios: [],
                searchTerm: payload.retainSearch ? state.searchTerm : '',
                selecting: false,
                sortBySelection: sortBy.CUSTOM,
                itemsSort: sortBy.CUSTOM,
                userHasChanged: false,
            };
        case SET_READY_TO_RENDER:
            return { ...state, readyToRender: payload.readyToRender };
        case ROUTER_NAVIGATION:
            return { ...state, routerNavigation: payload.routerNavigation };
        case SELECT_PORTFOLIOS:
            return { ...state, selectedPortfolios: payload.selectedPortfolios };
        case SELECT_ITEMS:
            return { ...state, selectedItems: payload.selectedItems };
        case SET_CREATE_FOLDER_ON_LOAD:
            return { ...state, createFolderOnLoad: payload.createFolderOnLoad };
        case SET_CURRENCY:
            return { ...state, currency: payload.currency };
        case SET_EDIT_MODE:
            return { ...state, editing: payload.editing };
        case SET_FAVORITE_ITEM_ON_LOAD:
            return { ...state, favoriteItemOnLoad: payload.favoriteItemOnLoad };
        case SET_FULL_PAGE_LOADING:
            return { ...state, isLoadingFullPage: payload.isLoadingFullPage };
        case SET_PARTIAL_PAGE_LOADING:
            return { ...state, isLoadingPartialPage: payload.isLoadingPartialPage };
        case SET_MUTATION_RESPONSE:
            return { ...state, mutationResponse: payload.mutationResponse };
        case SET_NUM_ITEMS:
            return { ...state, first: payload.first };
        case INCREASE_NUM_ITEMS:
            return { ...state, items: state.first + payload.items };
        case SET_PORTFOLIO_IDS:
            return { ...state, portfolioIds: payload.portfolioIds };
        case SET_PORTFOLIO_NAME:
            return { ...state, portfolioName: payload.portfolioName };
        case SET_PORTFOLIO_TYPES:
            return { ...state, portfolioTypes: payload.portfolioTypes };
        case SET_PORTFOLIO_VIEW_PERMISSION:
            return { ...state, portfolioViewPermission: payload.portfolioViewPermission };
        case SET_PROJECT_ID:
            return { ...state, projectId: payload.projectId };
        case SET_REORDERED:
            return { ...state, reordered: payload.reordered };
        case SET_REORDER_MODE:
            return { ...state, reordering: payload.reordering };
        case SET_SEARCH_TERM:
            return { ...state, searchTerm: payload.searchTerm };
        case SET_SELECT_ALL:
            return { ...state, selectAllStatus: payload.selectAllStatus };
        case SET_SELECT_MODE:
            return { ...state, selecting: payload.selecting };
        case SET_SORT_BY:
            return {
                ...state,
                sortBySelection: payload.sortBySelection,
                folderSort:
                    state.tab === tabs.FOLDER || state.tab === tabs.PROJECT
                        ? payload.sortBySelection
                        : state.folderSort,
                foldersSort:
                    state.tab === tabs.FOLDERS ? payload.sortBySelection : state.foldersSort,
                itemsSort: state.tab === tabs.ITEMS ? payload.sortBySelection : state.itemsSort,
            };
        case SET_TAB:
            return { ...state, tab: payload.tab };
        case SET_TAB_CHANGED:
            return { ...state, tabChanged: payload.tabChanged, shouldTrackReordering: true };
        case SET_TOTAL_RESULTS:
            return { ...state, totalResults: payload.totalResults };
        case SET_NUM_ITEMS:
        case SET_SHOULD_TRACK_REORDERING:
            return { ...state, shouldTrackReordering: payload.shouldTrackReordering };
        case SET_USER_HAS_CHANGED:
            return { ...state, userHasChanged: payload.userHasChanged };
        case SET_STICK_TOOLBAR:
            return { ...state, stickToolbar: payload.stickToolbar };
        case SLIDE_NAV_BORDER:
            return { ...state, navBorder: payload.navBorder };
        case SET_VIEWING_PUBLIC_VERSION:
            return { ...state, isPublic: payload.isPublic };
        case SET_VIEW_MODE:
            return { ...state, viewMode: payload.viewMode };
        case SET_AUTH_MODAL_STATE:
            return { ...state, authModalState: payload.authModalState };
        case SET_PAGE:
            return { ...state, page: payload.page };
        default:
            return state;
    }
};

export default uiState;
